import OnlyPrint from './OnlyPrint'
export default OnlyPrint